React = require 'react'
{ Component, PropTypes } = React
{ Button } = require 'react-bootstrap'
{ Link } = require 'react-router'
require '../../styles/Logout'

class Logout extends Component
	@propTypes:
		onLogout: PropTypes.func.isRequired

	@contextTypes:
		router: PropTypes.object.isRequired

	componentWillMount: =>
		@props.onLogout().then =>
			window.location.href = '/login'

	render: =>
		React.createElement("div", {"className": "logout fill-display"},
			React.createElement("div", {"className": "logout-notice"},
				React.createElement("div", {"className": "logged-out"}, """
\t\t\t\t\tLogging out...
""")
			)
		)

module.exports = Logout




// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/components/Logout.cjsx